module.exports = __webpack_public_path__ + "static/media/homeMessage.b592f6af.png";